import React, { useCallback, useEffect, useRef, useState } from 'react';
import MultiFactorAuthSetupDialogView from '../view/MultiFactorAuthSetupDialogView';

const MultiFactorAuthSetupDialogEngine = ({
  open,
  onClose: givenOnClose,
  userKey,
  emailAddress,
  oneTimeCodes,
  onCompleteFirstMFALogin
}) => {
  const linkRef = useRef(null);
  const codesRef = useRef(null);
  const [activeTab, setActiveTab] = useState('one');
  const [sixDigitCode, setSixDigitCode] = useState('');
  const [qrCode, setQrCode] = useState('');
  useEffect(() => {
    if (open) {
      setQrCode(
        `otpauth://totp/${
          emailAddress || ' '
        }?secret=${userKey}&issuer=Omnitrack`
      );
    }
  }, [emailAddress, open, userKey]);

  const onLinkCopy = useCallback(() => {
    if (!linkRef.current) {
      return;
    }
    linkRef.current.select();
    document.execCommand('copy');
    openSnackbar('success', 'form-builder.share.link.snackbar');
  }, []);
  const onNext = () => {
    setActiveTab('two');
  };
  const onShowOneTimeCodes = () => {
    setActiveTab('one-time-codes');
  };
  const onMFALogin = () => {
    onCompleteFirstMFALogin(sixDigitCode);
  };
  const onClose = () => {
    givenOnClose();
    setActiveTab('one');
  };

  const onChangeSixDigitCode = e => {
    let newValue = e.target.value;
    if (newValue.length > 6) {
      newValue = newValue.slice(0, 6);
    }

    setSixDigitCode(newValue);
  };

  const onSixDigitCodeKeyDown = e => {
    const ENTER_KEY_CODE = 13;
    if (e.keyCode !== ENTER_KEY_CODE) {
      return; // the key that was pressed is not Enter
    }
    onMFALogin();
  };

  const copyCodes = () => {
    if (!codesRef.current) {
      console.error('codesRef is not available');
      return;
    }

    codesRef.current.value = oneTimeCodes.join(', ');
    codesRef.current.select();
    document.execCommand('copy');
  };
  const downloadCodes = () => {
    const blob = new Blob([oneTimeCodes.join(', ')], { type: 'text/plain' });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'one-time-codes.txt';
    a.click();
    URL.revokeObjectURL(url);
  };

  const viewProps = {
    open,
    onClose,
    userKey,
    linkRef,
    codesRef,
    onLinkCopy,
    onNext,
    onShowOneTimeCodes,
    onMFALogin,
    activeTab,
    qrCode,
    sixDigitCode,
    onChangeSixDigitCode,
    onSixDigitCodeKeyDown,
    oneTimeCodes,
    copyCodes,
    downloadCodes
  };
  return <MultiFactorAuthSetupDialogView {...viewProps} />;
};

export default MultiFactorAuthSetupDialogEngine;
